<!--
 * @Author: your name
 * @Date: 2021-12-15 11:42:01
 * @LastEditTime: 2021-12-15 15:51:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\components\payment-subject-select\index.vue
-->
<template>
  <a-select
    :value="value"
    allow-clear
    :multiple="false"
    placeholder="请选择"
    option-filter-prop="title"
    @change="handleChange"
    @clear="onClear"
    class="w100"
    :class="class"
  >
    <a-select-option v-for="item in data" :key="item.id" :value="item.id" :title="item.name">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PaymentSubjectSel",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: String,
    },
    index: {
      type: Number,
      default: 0,
    },
    data: {
      type: Array,
      defaulf: [],
    },
    class: {
      type: String,
      default: "append-to-parentnode",
    },
  },
  emits: ["update:value", "paymentSubject"],
  setup(props, { emit }) {
    const handleChange = (id,e) => {
      emit("paymentSubject", { id: id, ...e });
      emit("update:value", id);
    };
    const onClear = () => {
      emit("update:value", "");
      emit("paymentSubject", { index: props.index });
    };

    return {
      handleChange,
      onClear,
    };
  },
});
</script>
